import * as _ from "lodash";
import * as angular from "angular";
import { FileUploader } from "angular-file-upload";
import { CheckManager } from "../../shared/check-manager";
import { DocumentDataProvider } from "../../data-provider/document.dp";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { Filter } from "../../models/filter.model";
import { Issue } from "../../models/issue.model";
import { User } from "../../models/user.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { NotificationDataProvider } from "../../data-provider/notification.dp";
import { PermissionCheck } from "../../shared/permission";
import { EmailService } from "../../services/email.service";
import { RemindersService } from "../../services/reminders.service";
import { UserDataProvider } from "../../data-provider/user.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { IssueDataProvider } from "../../data-provider/issue.dp";
import { Utils } from "../../helper/utils.helper";
import { issuePermissionIds } from "../../utils/user-permissions";
import { Campaign } from "../../models/campaign.model";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";

let IssuesComponent = {
    selector: "vcIssues",
    templateUrl: "/angular/components/issue/issues.component.html",
    bindings: {},
    controller: class IssueController {
        private $scope: any;
        private $timeout: any;
        private $routeParams: any;
        public __env: any;
        private $location: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private modelsUtils: any;
        private utils: Utils;

        private dataProvider: IssueDataProvider;
        private filterDataProvider: FilterDataProvider;
        private emailService: EmailService;
        private documentDataProvider: DocumentDataProvider;
        private remindersService: RemindersService;
        private navigationBarService: NavigationBarHelperService;
        private notificationDataProvider: NotificationDataProvider;
        private permissionProvider: PermissionCheck;
        private userDataProvider: UserDataProvider;

        public chatTab: string = "note";
        public issueEmailForm: any = {};
        public issue: Issue;
        public email: any;
        public note: object = { csqalog: "", type: "note" };
        public showIssueDetails: boolean = false;
        public uploader: FileUploader;
        public checkManager: CheckManager;
        public chatBoxHidden: boolean = false;
        public filter: Filter;
        public statuses: Array<any>;
        public savingNote: boolean = false;
        public sendToInputOpen = false;
        public consentSettings: any;
        public previousIssue: Issue;
        public user: User;
        public activeCampaign: Campaign;
        public issuePermissions = issuePermissionIds();

        constructor(
            $scope: any,
            $timeout: any,
            ToastUtils: ToastUtils,
            $routeParams: any,
            IssueDataProvider: IssueDataProvider,
            FilterDataProvider: FilterDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            EmailService: EmailService,
            DialogUtils: DialogUtils,
            $location: any,
            ModelsUtils: any,
            DocumentDataProvider: DocumentDataProvider,
            RemindersService: RemindersService,
            NavigationBarHelperService: NavigationBarHelperService,
            NotificationDataProvider: NotificationDataProvider,
            Utils: Utils,
            PermissionCheck: PermissionCheck,
            __env: any,
            UserDataProvider: UserDataProvider
        ) {
            this.$scope = $scope;
            this.utils = Utils;
            this.utils.accessCheck();
            this.utils.runWootric();
            this.$timeout = $timeout;
            this.toast = ToastUtils;
            this.$routeParams = $routeParams;
            this.dataProvider = IssueDataProvider;
            this.filterDataProvider = FilterDataProvider;
            this.emailService = EmailService;
            this.dialog = DialogUtils;
            this.$location = $location;
            this.documentDataProvider = DocumentDataProvider;
            this.modelsUtils = ModelsUtils;
            this.remindersService = RemindersService;
            this.navigationBarService = NavigationBarHelperService;
            this.notificationDataProvider = NotificationDataProvider;
            this.permissionProvider = PermissionCheck;
            this.__env = __env;
            this.userDataProvider = UserDataProvider;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
            this.user = this.userDataProvider.getActiveUser();
            this.email = {
                sender: this.user,
                recipient: null,
                attachments: [],
            };

            if (!this.permissionProvider.hasPermission("ISSUE")) {
                return;
            }

            this.issue = this.dataProvider.issue;
            this.issue.loading = true;
            this.uploader = this.documentDataProvider.getFileUploader(2);
            this.uploader.onSuccessItem = (_, response: any) => {
                this.$timeout(() => {
                    this.email.attachments.unshift(
                        this.modelsUtils.document(response.data)
                    );
                });
            };
            this.uploader.onWhenAddingFileFailed = (item) => {
                this.toast.error("File is not supported");
            };
            this.notificationDataProvider.setIssuesSeen();
            this.checkManager = this.dataProvider.checkManager;
            this.checkManager.hideNavOnCheckAll = false;
            this.filter = this.$location.search();
            this.filter.search = "";
            if (this.$routeParams.csqid || !this.filter.csqid) {
                this.filter.csqid = this.$routeParams.csqid;
                this.$routeParams.csqid = null;
            }
            this.issue.csqid = this.filter.csqid ? this.filter.csqid : null;

            if (!this.navigationBarService.smallScreen && this.issue.csqid) {
                this.dataProvider
                    .getIssue(this.issue.csqid)
                    .then((issue: Issue) => {
                        this.issue = issue;
                    });
            } else {
                this.issue = this.dataProvider.issue;
            }

            this.filter.status = this.filter.status ? this.filter.status : "6";
            this.filterDataProvider.filter = this.filter;

            this.dataProvider.getStatuses().then((statuses) => {
                this.statuses = statuses;
            });
            this.permissionProvider
                .getConsentSettings()
                .then((consentSettings) => {
                    this.consentSettings = consentSettings;
                });
        }

        $onInit() {
            this.previousIssue = _.cloneDeep(this.issue);
        }

        $doCheck() {
            if (this.issue && !angular.equals(this.issue, this.previousIssue)) {
                if (this.issue.logs) {
                    angular.forEach(
                        this.issue.logs,
                        (log: object, index: number) => {
                            this.dataProvider.thumbnailForLogItem(log);
                        }
                    );
                }
                if (
                    this.issue.houseoccupant &&
                    this.issue.houseoccupant.hoemail
                ) {
                    this.sendToInputOpen = false;
                    this.email.recipient = _.cloneDeep(
                        this.issue.houseoccupant.hoemail
                    );
                } else {
                    this.sendToInputOpen = true;
                    this.email.recipient = "";
                }

                if (this.issue.houseoccupant) {
                    this.issue.houseoccupant.allowedEmail =
                        angular.isUndefined(
                            this.issue.houseoccupant.selected_contactmethods
                        ) ||
                        this.issue.houseoccupant.selected_contactmethods
                            .length == 0 ||
                        (this.issue.houseoccupant.selected_contactmethods.indexOf(
                            "4"
                        ) > -1 &&
                            this.issue.houseoccupant.selected_contactmethods.indexOf(
                                "1"
                            ) == -1);
                } else {
                    this.issue.houseoccupant = this.modelsUtils.houseOccupant({
                        allowedEmail: true,
                    });
                }

                if (!this.issue.houseoccupant.allowedEmail) {
                    this.chatTab = "note";
                }

                if (this.issue.csqid == this.previousIssue.csqid) {
                    if (
                        this.issue.assigned &&
                        this.issue.assigned.uid &&
                        this.issue.assigned.uid !=
                            this.previousIssue.assigned.uid
                    ) {
                        this.createAssignedLog(this.issue);
                    }
                }
                this.previousIssue = _.cloneDeep(this.issue);
            }
        }

        addIssueNote(note: any): void {
            this.savingNote = true;
            this.dataProvider.addNote(note, this.issue).then(() => {
                this.savingNote = false;
                note.csqalog = "";
            });
        }

        navigateToEmail(note: any): void {
            if (this.activeCampaign.inTrialMode()) {
                this.chatTab = "note";
                this.dialog.show({
                    component: "vc-feature-disabled-dialog",
                    size: "large",
                    scope: this.$scope,
                    locals: {
                        title: "Helpdesk emails only available on paid subscriptions",
                        body: "The email feature of Helpdesk is restricted during your free trial period. To enable this feature, please contact our support team to request to end your trial period early and switch to a paid subscription",
                    },
                });
                this.chatTab = "note";
                this.$timeout(() => {
                    this.chatTab = "note";
                }, 10);
            } else {
                this.chatTab = "email";
            }
        }

        deleteReminder(reminder: any, ev: object): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    locals: {
                        title: "Delete Reminder?",
                        bodyText: "This will permanently delete the reminder",
                    },
                })
                .then(() => {
                    this.remindersService
                        .delete({ id: reminder.rmid })
                        .then(() => {
                            let reminderIndex =
                                this.issue.reminders.indexOf(reminder);
                            if (reminderIndex > -1) {
                                this.issue.reminders.splice(reminderIndex, 1);
                            }
                        });
                });
        }

        sendEmail(email: any): void {
            email.csqid = this.issue.csqid;
            this.emailService.send(email).then((response: object) => {
                const json = response["data"];
                if (json.success) {
                    this.resetEmail();
                    _.merge(this.issue, json.data);
                }
            });
        }

        resetEmail(discardEmail?: boolean): void {
            this.email.body = "";
            this.email.subject = "";
            this.email.attachments.splice(0, this.email.attachments.length);
            this.sendToInputOpen = false;
            if (
                discardEmail &&
                this.email.recipient != this.issue.houseoccupant.hoemail
            ) {
                this.email.recipient = "";
            }
            if (!this.email.recipient || this.email.recipient == "") {
                this.sendToInputOpen = true;
            }
            this.issueEmailForm.form.$setPristine();
            this.issueEmailForm.form.$setUntouched();
        }

        createPriorityLog(issue: Issue): void {
            this.dataProvider.setPriority(issue);
        }

        createAssignedLog(issue: Issue): void {
            this.dataProvider.setAssigned(issue).then(() => {
                if (
                    this.filter.assigned &&
                    issue.assigned.uid != this.user.uid
                ) {
                    this.dataProvider.spliceIssue(issue);
                } else {
                    this.dataProvider.replaceIssue(issue);
                }
            });
        }

        createStatusLog(issue: Issue): void {
            let data = _.cloneDeep(issue);
            data["assigned"] = this.filter.assigned;

            this.dataProvider.setStatus(data).then((returnedIssue) => {
                issue.setData(returnedIssue);
                if (this.filter.status != "6") {
                    this.dataProvider.spliceIssue(issue, true);
                }
            });
        }

        openCreateIssueDialog(ev: object): void {
            this.dialog
                .show({
                    component: "vc-create-issue",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Change Custom Field",
                    class: "create-issue-dialog",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: null,
                        selectedHoid: null,
                        selectedCanvasser: null,
                        dialogType: "issue",
                    },
                })
                .then((issueData) => {
                    this.issue.loading = true;
                    this.dataProvider.createIssue(issueData).then(() => {
                        this.issue.loading = false;
                        this.checkManager.matched_count += 1;
                        this.toast.success("Logged follow-up request.");
                    });
                });
        }

        toggleIssueDetails(bool: boolean): void {
            this.showIssueDetails = bool;
        }

        openDeleteIssueDialog(issue: Issue, ev): void {
            this.dialog
                .show({
                    component: "vc-issue-delete",
                    targetEvent: ev,
                    skipHide: true,
                    clickOutsideToClose: true,
                    ariaLabel: "Delete follow-up request",
                    scope: this.$scope,
                    locals: {
                        selectedIssue: issue,
                    },
                })
                .then((issue) => {
                    this.dataProvider.deleteIssue(issue).then(() => {
                        this.toast.success("Follow-up request deleted");
                    });
                });
        }

        openIssueReminderDialog(issue: Issue, ev: object): void {
            if (issue.csqaassigned) {
                this.dialog
                    .show({
                        component: "vc-issue-reminder",
                        targetEvent: ev,
                        skipHide: true,
                        clickOutsideToClose: true,
                        ariaLabel: "Change follow-up request status",
                        scope: this.$scope,
                        locals: {
                            selectedIssue: issue,
                        },
                    })
                    .then((reminder) => {
                        this.remindersService
                            .create(reminder)
                            .then((response: object) => {
                                const json = response["data"];
                                this.issue.reminders.push(json.data);

                                if (json.success !== false) {
                                    this.toast.success(
                                        "Follow-up request reminder created"
                                    );
                                }
                            });
                    });
            } else {
                const alertDialog = this.dialog
                    .alert()
                    .textContent(
                        "Reminders are sent to the user that is assigned to the follow-up request. Please assign this follow-up request to someone before creating a reminder."
                    )
                    .targetEvent(ev)
                    .ok("OK");
                this.dialog.showPreConfiguredDialog(alertDialog);
            }
        }

        daysLeft(lastEditedDate: string): number {
            let lastEdited = new Date(lastEditedDate);
            let today = new Date();
            let timeDiff = Math.abs(today.getTime() - lastEdited.getTime());
            let diffDays = Math.round(timeDiff / (1000 * 3600 * 24));

            return 30 - diffDays;
        }

        toggleChatBox(): void {
            this.chatBoxHidden = !this.chatBoxHidden;
        }

        openEditHouseOccupantDialog(issue: Issue, ev: object): void {
            this.dialog
                .show({
                    component: "vc-house-occupant-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    skipHide: true,
                    clickOutsideToClose: false,
                    locals: {
                        selectedHoid: issue.houseoccupant.hoid,
                        selectedHid: null,
                    },
                    ariaLabel: "Person",
                    size: "large",
                })
                .then((data: object): void => {
                    issue.houseoccupant.setData(data);
                    this.dataProvider.reloadData();
                });
        }
    },
};

angular.module("issue").component(IssuesComponent.selector, IssuesComponent);
